var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"css-content",domProps:{"innerHTML":_vm._s(_vm.cssContent)}}),_c('div',{directives:[{name:"dompurify-html",rawName:"v-dompurify-html",value:(_vm.htmlBody),expression:"htmlBody"}],ref:"htmlContainer",class:[
      'html-content',
      { 'mystage-view-ipad': _vm.isIpadDevice },
      { 'mystage-view-pc': !_vm.isMobileWidth && !_vm.isIpadDevice },
      { 'cms-safari': _vm.isSafariBrowser }
    ],style:(_vm.zoomPdfHtmlMaterial)})])}
var staticRenderFns = []

export { render, staticRenderFns }